import i18n from '../i18n';

const localizationRequestInterceptor = function (config: any) {
   config.headers = {
      'Accept-Language': i18n.global.locale.value,
      ...config.headers,
   };

   return config;
};

export { localizationRequestInterceptor };
